import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ProductMode } from '@common/models';
import { AuthStateService } from '@common/services/auth/auth-state.service';
import { environment } from '@env/environment';
import { IconSpriteModule } from 'ng-svg-icon-sprite';

@Component({
  imports: [IconSpriteModule],
  selector: 'app-footer',
  templateUrl: './app-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppFooterComponent {
  private readonly authState = inject(AuthStateService);

  protected readonly ProductMode = ProductMode;
  protected readonly path = environment.spriteBase + 'logo';

  protected readonly systemInfo = this.authState.systemInfo;
}
